var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopAgentsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1.87rem",
    viewBox: "0 0 43.367 30.357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "users-line-solid",
    d: "M14.311,36.337a4.337,4.337,0,1,0-4.337,4.337A4.337,4.337,0,0,0,14.311,36.337ZM2.168,47.178a2.166,2.166,0,0,0,2.168,2.168h5.8a8.682,8.682,0,0,1,5.136-5.868,4.3,4.3,0,0,0-2.263-.637H6.505A4.341,4.341,0,0,0,2.168,47.178Zm31.278,2.168H39.03A2.166,2.166,0,0,0,41.2,47.178a4.341,4.341,0,0,0-4.337-4.337H30.357a4.3,4.3,0,0,0-2.175.583A8.7,8.7,0,0,1,33.447,49.347Zm-6.939-4.174a6.5,6.5,0,0,0-1.464-.163H18.539a6.673,6.673,0,0,0-1.66.21,6.514,6.514,0,0,0-4.852,6.295A2.166,2.166,0,0,0,14.2,53.683H29.374a2.166,2.166,0,0,0,2.168-2.168,6.394,6.394,0,0,0-.373-2.168A6.513,6.513,0,0,0,26.5,45.173Zm11.655-8.836a4.337,4.337,0,1,0-4.337,4.337A4.337,4.337,0,0,0,38.163,36.337ZM21.792,42.842a5.421,5.421,0,1,0-5.421-5.421A5.421,5.421,0,0,0,21.792,42.842ZM2.168,58.02a2.168,2.168,0,0,0,0,4.337H41.2a2.168,2.168,0,1,0,0-4.337Z",
    transform: "translate(0 -32)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopAgentsIcon);
export default __webpack_public_path__ + "static/media/top-agents-icon.1346095e4862a65e56a2fb7c29143e9b.svg";
export { ForwardRef as ReactComponent };